import { Component } from "@angular/core";

@Component({
  selector: "evrideo-take-over-confirm-dialog",
  templateUrl: "./take-over-confirm-dialog.component.html",
  styleUrls: ["./take-over-confirm-dialog.component.scss"],
})
export class TakeOverConfirmDialogComponent {
  currentUsername: string;
  dialogConfirm: () => void;
  dialogCancel: () => void;

  onCancel(): void {
    this.dialogCancel?.();
  }

  onSlideConfirmed(): void {
    this.dialogConfirm?.();
  }
}
